<script lang="ts">
	import { onDestroy } from "svelte";
	import ProxyTextareaElement from "./core";
	export let value = "";
	export let minRows: number = 1;
	export let maxRows: number = 4;
	export let onKeyPress: (e: KeyboardEvent) => void = () => {};
	export let onBlur: () => void = () => {};
	export let onFocus: () => void = () => {};
	export let ref: HTMLTextAreaElement | null = null;
	export let withButton: boolean = false;
	export let isRequired: boolean = false;
	export let smallInput: boolean = false;
	export let demoInput: boolean = false;
	let element: HTMLTextAreaElement;
	const instance = new ProxyTextareaElement();
	$: {
	  if (element && !instance.hasStarted)
	    instance.start(element, minRows, maxRows);
	  if (instance.hasStarted)
	    instance.onUpdateText((value || "").toString());
	}
	$: {
		if (ref) {
			ref = element;
		}
	}
	onDestroy(() => {
	  instance.cleanUp();
	});
</script>

<textarea
	{...$$props}
	on:keypress={onKeyPress}
	on:focus={onFocus}
	on:blur={onBlur}
	bind:this={element}
	bind:value={value}
	enterkeyhint={smallInput ? "send" : "enter"}
	class:withButton
	required={isRequired}
	class:smallInput
	class:demoInput
></textarea>

<style lang="scss">
	textarea {
		all: unset;
		box-sizing: border-box;
		font-size: 16px;
		resize: none;
		width: 100%;
		padding: 14px;
		height: 56px;
		line-height: 19px;
		overflow-y: auto;
		color: var(--chat-input-text-color);
		&::placeholder {
			color: var(--chat-input-text-color);
			opacity: 0.5;
		}

		&.withButton {
			padding: 14px 40px 14px 6px;
		}
		&.demoInput {
			padding: 14px 40px 14px 14px;
		}
		&.smallInput {
			padding: 6px 4px 6px 10px;
			height: auto;
			min-height: 30px;
			font-weight: 300;
			font-size: 14px;
			line-height: 14px;
			color: white;
		}
	}
</style>